module.exports = __webpack_public_path__ + "img/background-video-slider-infiniti.e04efac9.png";